export default __webpack_public_path__ + "static/media/mx.d2882058.png";